import Box from '@mui/material/Box';
import { textStyles, hyperlinkStyles } from './styles';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import TimestampFooter from '../TimestampFooter';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { v4 as uuid } from 'uuid';
import useTheme from '@mui/material/styles/useTheme';

const TextBodyWithHyperLinks = ({ tokens, message, isOutgoing }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography sx={textStyles(isOutgoing)}>
        <For each="token" of={tokens}>
          <Choose>
            <When condition={token.startsWith('http')}>
              <Button
                sx={hyperlinkStyles(theme)}
                href={token}
                size="small"
                variant="text"
                target="_blank"
                rel="noopener noreferrer"
                key={uuid()}
              >
                {token}
              </Button>
            </When>

            <Otherwise>{token}</Otherwise>
          </Choose>
        </For>
      </Typography>

      <If condition={message.isLastMessageInParticipantBatch}>
        <TimestampFooter
          timestamp={DateTime.fromJSDate(message.timestamp).toLocaleString(
            DateTime.DATETIME_SHORT
          )}
        />
      </If>
    </Box>
  );
};

TextBodyWithHyperLinks.propTypes = {
  isOutgoing: PropTypes.bool.isRequired,
  tokens: PropTypes.arrayOf(PropTypes.string).isRequired,
  message: PropTypes.shape({
    isLastMessageInParticipantBatch: PropTypes.bool.isRequired,
    timestamp: PropTypes.instanceOf(Date).isRequired,
  }),
};

export default TextBodyWithHyperLinks;
